import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const adminOauthCredentialsResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-admin-oauth-credentials", jiraSpaEntry: "async-resource-admin-oauth-credentials" */ './getDataWithErrorLogging.tsx'
		),
});
